import styled from 'styled-components';
import { palette } from 'styled-tools';

export const Wrapper = styled.div`
	color: ${palette('black')};
	margin-bottom: 54px;
	text-align: center;

	& p {
		font-size: 13.5px;
	}
`;
